var NotAuthController = (function () {
    function NotAuthController($window, env, $timeout) {
        this.$window = $window;
        this.env = env;
        this.$timeout = $timeout;
        this.hey = 'HEY';
    }
    NotAuthController.prototype.logOut = function () {
        var _this = this;
        console.log('clearing cookies');
        this.env.revokeUser();
        // 1 second added, becaues window
        this.$timeout(function () {
            _this.$window.location.href = '/logout';
        }, 1000);
    };
    NotAuthController.$inject = ['$window', 'env', '$timeout'];
    return NotAuthController;
}());
var NotAuthComponent = (function () {
    function NotAuthComponent() {
        this.templateUrl = '500.html';
        this.controllerAs = 'vm';
        this.controller = NotAuthController;
    }
    return NotAuthComponent;
}());
angular
    .module('application')
    .component('notAuthSection', new NotAuthComponent());

//# sourceMappingURL=500.component.js.map
